import { render, staticRenderFns } from "./StudentSidebar.vue?vue&type=template&id=034e17fb&"
import script from "./StudentSidebar.vue?vue&type=script&lang=js&"
export * from "./StudentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StudentSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports